import styled from "styled-components";
const BottomCardLineChartWrapper = styled.div``;

export default BottomCardLineChartWrapper;
